import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './Cases.css'
import { trackCtaClick } from 'services/analyticsService'

const Cases = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleCaseCtaClick = ({ caseTitleKey, categoryKey, destination }) => {
    const ctaText = t('cases_page.card.cta')
    const caseTitle = t(caseTitleKey)
    const category = t(categoryKey)

    trackCtaClick({
      cta_name: 'cases_conhecer_produtos',
      cta_location: 'cases',
      case_title: caseTitle,
      case_category: category,
      destination_path: destination,
      cta_text: ctaText,
    })

    navigate(destination)
  }

  const categories = [
    {
      title: 'cases_page.categories.aiAgents.title',
      items: [
        {
          id: 1,
          title: 'cases_page.categories.aiAgents.items.hubDeIa.title',
          url: 'hub-de-ia',
          description: 'cases_page.categories.aiAgents.items.hubDeIa.description',
        },
        {
          id: 2,
          title: 'cases_page.categories.aiAgents.items.leitorDePedidos.title',
          url: 'leitor-de-pedidos',
          description: 'cases_page.categories.aiAgents.items.leitorDePedidos.description',
        },
        {
          id: 3,
          title: 'cases_page.categories.aiAgents.items.iaAssistenteDeManutencao.title',
          url: 'ia-assistente-de-manutencao',
          description:
            'cases_page.categories.aiAgents.items.iaAssistenteDeManutencao.description',
        },
        {
          id: 4,
          title: 'cases_page.categories.aiAgents.items.iaAssistenteRh.title',
          url: 'ia-assistente-rh',
          description: 'cases_page.categories.aiAgents.items.iaAssistenteRh.description',
        },
        {
          id: 5,
          title: 'cases_page.categories.aiAgents.items.customerInsights.title',
          url: 'customer-insights',
          description:
            'cases_page.categories.aiAgents.items.customerInsights.description',
        },
      ],
    },
    {
      title: 'cases_page.categories.data.title',
      items: [
        {
          id: 6,
          title: 'cases_page.categories.data.items.delfos.title',
          url: 'delfos',
          description: 'cases_page.categories.data.items.delfos.description',
        },
        {
          id: 7,
          title: 'cases_page.categories.data.items.fretesAnalytics.title',
          url: 'fretes-analytics',
          description: 'cases_page.categories.data.items.fretesAnalytics.description',
        },
        {
          id: 8,
          title: 'cases_page.categories.data.items.kanban.title',
          url: 'kanban',
          description: 'cases_page.categories.data.items.kanban.description',
        },
        {
          id: 9,
          title: 'cases_page.categories.data.items.fretesMachineLearning.title',
          url: 'fretes-machine-learning',
          description:
            'cases_page.categories.data.items.fretesMachineLearning.description',
        },
        {
          id: 10,
          title: 'cases_page.categories.data.items.fretesInsights.title',
          url: 'fretes-insights',
          description: 'cases_page.categories.data.items.fretesInsights.description',
        },
        {
          id: 11,
          title: 'cases_page.categories.data.items.integraSapIbp.title',
          url: 'integra-SAP-IBP',
          description: 'cases_page.categories.data.items.integraSapIbp.description',
        },
        {
          id: 12,
          title: 'cases_page.categories.data.items.estruturaDadosHorizontal.title',
          url: 'estrutura-de-dados-horizontal',
          description:
            'cases_page.categories.data.items.estruturaDadosHorizontal.description',
        },
        {
          id: 13,
          title: 'cases_page.categories.data.items.qualidadeEGovernanca.title',
          url: 'qualidade-e-governanca',
          description:
            'cases_page.categories.data.items.qualidadeEGovernanca.description',
        },
        {
          id: 14,
          title: 'cases_page.categories.data.items.migracaoDeDadosDatabricks.title',
          url: 'migracao-de-dados-databricks',
          description:
            'cases_page.categories.data.items.migracaoDeDadosDatabricks.description',
        },
      ],
    },
    {
      title: 'cases_page.categories.digitalSupplyChain.title',
      items: [
        {
          id: 15,
          title: 'cases_page.categories.digitalSupplyChain.items.previsaoDeDemanda.title',
          url: 'previsao-de-demanda',
          description:
            'cases_page.categories.digitalSupplyChain.items.previsaoDeDemanda.description',
        },
        {
          id: 16,
          title:
            'cases_page.categories.digitalSupplyChain.items.abastecimentoEEstoque.title',
          url: 'abastecimento-e-politica-de-estoque',
          description:
            'cases_page.categories.digitalSupplyChain.items.abastecimentoEEstoque.description',
        },
        {
          id: 17,
          title:
            'cases_page.categories.digitalSupplyChain.items.confirmacaoDeDisponibilidade.title',
          url: 'confirmacao-de-disponibilidade',
          description:
            'cases_page.categories.digitalSupplyChain.items.confirmacaoDeDisponibilidade.description',
        },
        {
          id: 18,
          title:
            'cases_page.categories.digitalSupplyChain.items.ajusteDeMalhaLogisticaAps.title',
          url: 'malha-logistica-no-sistema',
          description:
            'cases_page.categories.digitalSupplyChain.items.ajusteDeMalhaLogisticaAps.description',
        },
        {
          id: 19,
          title:
            'cases_page.categories.digitalSupplyChain.items.planejamentoEOtimizacao.title',
          url: 'planejamento-e-otimizacao',
          description:
            'cases_page.categories.digitalSupplyChain.items.planejamentoEOtimizacao.description',
        },
        {
          id: 20,
          title:
            'cases_page.categories.digitalSupplyChain.items.planejamentoNaIndustria.title',
          url: 'planejamento-na-industria',
          description:
            'cases_page.categories.digitalSupplyChain.items.planejamentoNaIndustria.description',
        },
        {
          id: 21,
          title: 'cases_page.categories.digitalSupplyChain.items.projetoDreams.title',
          url: 'projeto-dreams',
          description:
            'cases_page.categories.digitalSupplyChain.items.projetoDreams.description',
        },
        {
          id: 22,
          title:
            'cases_page.categories.digitalSupplyChain.items.integraSapIbpSupplyResp.title',
          url: 'integra-SAP-IBP-supply-chain',
          description:
            'cases_page.categories.digitalSupplyChain.items.integraSapIbpSupplyResp.description',
        },
      ],
    },
    {
      title: 'cases_page.categories.digital.title',
      items: [
        {
          id: 23,
          title: 'cases_page.categories.digital.items.plataformaDeECommerce.title',
          url: 'plataforma-de-e-commerce',
          description:
            'cases_page.categories.digital.items.plataformaDeECommerce.description',
        },
        {
          id: 24,
          title: 'cases_page.categories.digital.items.plataformaDeGestaoDePrecos.title',
          url: 'plataforma-de-gestao-de-precos',
          description:
            'cases_page.categories.digital.items.plataformaDeGestaoDePrecos.description',
        },
        {
          id: 25,
          title: 'cases_page.categories.digital.items.plataformaDeExportacao.title',
          url: 'plataforma-de-exportacao',
          description:
            'cases_page.categories.digital.items.plataformaDeExportacao.description',
        },
      ],
    },
    {
      title: 'cases_page.categories.cx.title',
      items: [
        {
          id: 26,
          title: 'cases_page.categories.cx.items.roadmaps.title',
          url: 'road-maps',
          description: 'cases_page.categories.cx.items.roadmaps.description',
        },
        {
          id: 27,
          title: 'cases_page.categories.cx.items.redesenhoDoFluxo.title',
          url: 'redesenho-do-fluxo',
          description: 'cases_page.categories.cx.items.redesenhoDoFluxo.description',
        },
        {
          id: 28,
          title: 'cases_page.categories.cx.items.serviceDesignSac.title',
          url: 'service-design-SAC',
          description: 'cases_page.categories.cx.items.serviceDesignSac.description',
        },
        {
          id: 29,
          title: 'cases_page.categories.cx.items.complexVarejo.title',
          url: 'complex',
          description: 'cases_page.categories.cx.items.complexVarejo.description',
        },
      ],
    },
  ]

  return (
    <section className="main-container">
      <header className="main-container-top">
        <div className="text">
          <h1 className="hero-title">{t('cases_page.title')}</h1>
          <p>{t('cases_page.subtitle')}</p>
        </div>
        <div className="image-container">
          <img src="/assets/Home/multidevice.png" alt={t('cases_page.imageAlt')} />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          {categories.map((cat) => (
            <div key={cat.title} className="CategoryGroup">
              <h2 className="CategoryTitle">{t(cat.title)}</h2>
              <div className="CardsGroup">
                {cat.items.map((item) => (
                  <div className="CaseCard" key={item.id}>
                    <img
                      src="/assets/Cases/CasesPage/barras.png"
                      alt={t('cases_page.card.graphicAlt')}
                      className="Graphic"
                    />
                    <h3>{t(item.title)}</h3>
                    <p>{t(item.description)}</p>
                    <button
                      onClick={() =>
                        handleCaseCtaClick({
                          caseTitleKey: item.title,
                          categoryKey: cat.title,
                          destination: `/${item.url}`,
                        })
                      }
                    >
                      {t('cases_page.card.cta')}
                      <img
                        src="/assets/Home/SVG - Seta para frente.png"
                        alt={t('cases_page.card.arrowAlt')}
                      />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Cases
